import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../InventoryManagementClient';

import {
  INBOUND_INVENTORY_INFO_KEY,
  INBOUND_HISTORY_LIST_KEY,
  INBOUND_SEARCH_LIST_KEY,
} from '../clients/inbound';
import { INBOUND_COURIER_INFO_KEY } from '../clients/inventory';

/**
 * This is to track the mutation key for scanning a pod
 */
const MUT_COURIER_DRIVER_INFO = 'courier-driver-info-mutation';

interface IScanPodMutationParam {
  onError?: (err: IApiError) => void;
  onSuccess?: () => void;
}

/**
 * React Query mutation function for updating the courier driver info.
 */
export const useUpdateCourierDriverInfoMutation = ({
  onError,
  onSuccess,
}: IScanPodMutationParam) => {
  const queryClient = useQueryClient();

  const { isPending, isError, error, mutate, isSuccess, reset } = useMutation({
    mutationKey: [MUT_COURIER_DRIVER_INFO],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.updateCourierDriverInfo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INBOUND_COURIER_INFO_KEY] });
      queryClient.invalidateQueries({ queryKey: [INBOUND_INVENTORY_INFO_KEY] });
      queryClient.invalidateQueries({ queryKey: [INBOUND_HISTORY_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [INBOUND_SEARCH_LIST_KEY] });

      onSuccess?.();
    },
    onError,
  });

  return {
    error,
    isError,
    isPending,
    isSuccess,
    resetUpdateCourierInfo: reset,
    updateCourierInfo: mutate,
  };
};
